module.exports = __webpack_public_path__ + "img/toe_touch_1.789b46fd.png";